var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOther = function SvgOther(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 4C5.39543 4 4.5 4.89543 4.5 6V12C4.5 13.1046 5.39543 14 6.5 14H12.5C13.6046 14 14.5 13.1046 14.5 12V6C14.5 4.89543 13.6046 4 12.5 4H6.5ZM6.5 6H12.5V12H6.5V6ZM6.5 18C5.39543 18 4.5 18.8954 4.5 20V26C4.5 27.1046 5.39543 28 6.5 28H12.5C13.6046 28 14.5 27.1046 14.5 26V20C14.5 18.8954 13.6046 18 12.5 18H6.5ZM6.5 20H12.5V26H6.5V20ZM18.5 6C18.5 4.89543 19.3954 4 20.5 4H26.5C27.6046 4 28.5 4.89543 28.5 6V12C28.5 13.1046 27.6046 14 26.5 14H20.5C19.3954 14 18.5 13.1046 18.5 12V6ZM26.5 6H20.5V12H26.5V6ZM20.5 18C19.3954 18 18.5 18.8954 18.5 20V26C18.5 27.1046 19.3954 28 20.5 28H26.5C27.6046 28 28.5 27.1046 28.5 26V20C28.5 18.8954 27.6046 18 26.5 18H20.5ZM20.5 20H26.5V26H20.5V20Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOther, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/other.3965760e.svg";
export { ForwardRef as ReactComponent };